document.addEventListener('DOMContentLoaded', () => {
  const menuButton = document.querySelector('.header__button');
  const menu = document.querySelector('#modal-menu');
  const mainContent = document.querySelector('#main-content');

  if (!menuButton || !menu) return;

  const focusableElements = menu.querySelectorAll('a, button, [tabindex]:not([tabindex="-1"])');
  const firstFocusableElement = focusableElements[0];
  const lastFocusableElement = focusableElements[focusableElements.length - 1];

  function toggleMenu(show) {
    const isOpen = show !== undefined ? show : menuButton.getAttribute('aria-expanded') === 'false';
    menuButton.setAttribute('aria-expanded', isOpen);
    menu.classList.toggle('is-open', isOpen);
    menu.hidden = !isOpen;

    if (isOpen) {
      if (mainContent) mainContent.setAttribute('inert', '');
      if (firstFocusableElement) setTimeout(() => firstFocusableElement.focus(), 100);
    } else {
      if (mainContent) mainContent.removeAttribute('inert');
      menuButton.focus();
    }
  }

  menuButton.addEventListener('click', () => toggleMenu());

  menu.addEventListener('keydown', (e) => {
    if (e.key === 'Tab') {
      if (e.shiftKey) {
        if (document.activeElement === firstFocusableElement) {
          e.preventDefault();
          lastFocusableElement.focus();
        }
      } else {
        if (document.activeElement === lastFocusableElement) {
          e.preventDefault();
          firstFocusableElement.focus();
        }
      }
    }

    if (e.key === 'Escape') {
      toggleMenu(false);
    }
  });

  document.addEventListener('click', (e) => {
    if (!menu.contains(e.target) && !menuButton.contains(e.target) && menu.classList.contains('is-open')) {
      toggleMenu(false);
    }
  });
});
